import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDetailsLine } from '../../../types/joinOtaLegalShort/detailsLine';
import { TVerifyUserErrorCode } from '../../../types/joinOtaLegalShort/verifyUserErrorCode';

export interface ILegalDataState {
  legalDetails: IDetailsLine[];
  contactDetails: IDetailsLine[];
  error?: TVerifyUserErrorCode;
}

export const initialState: ILegalDataState = {
  legalDetails: [],
  contactDetails: [],
};

const legalDataSlice = createSlice({
  name: 'legalData',
  initialState,
  reducers: {
    setLegalData(_, action: PayloadAction<ILegalDataState>) {
      return action.payload;
    },
  },
});

export const {
  reducer: legalDataReducer,
  actions: { setLegalData },
} = legalDataSlice;
